module.exports = __webpack_public_path__ + "img/top-pet.7682317.jpg";